import React, { useRef, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './components/Navbar.css';
import Login from './components/Login/Login';
import Navbar from './components/navbar.component';
import EventsList from './components/events-list.component';
import EditAppointment from './components/edit-appointment.component';
import EditProfile from './components/edit-profile.component';
import BotStatus from './components/BotStatus/BotStatus';
import SetupBot from './components/BotStatus/SetupBot';
import Setup2FA from './components/TwoFA/Setup2FA';
import Verify2FA from './components/TwoFA/Verify2FA';
import Administration from './components/Administration/Administration';
import auth from './components/AuthService';

// Route guard: redirect to / if user is not admin
function AdminRoute({ children }) {
  if (!auth.isAdmin()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

// Route guard: redirect to / if no tempToken for 2FA setup
function TwoFASetupRoute({ children }) {
  if (!auth.getTempToken()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  const eventsListRef = useRef(null);
  const [botStatus, setBotStatus] = useState([]);

  const handleRefresh = () => {
    if (eventsListRef.current) {
      eventsListRef.current.refreshEvents();
    }
  };

  useEffect(() => {
    const fetchBots = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const res = await fetch('/bots/status', {
          headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
        });
        if (res.ok) {
          const data = await res.json();
          setBotStatus(data);
        }
      } catch (_) { }
    };
    fetchBots();
    const interval = setInterval(fetchBots, 10000);
    return () => clearInterval(interval);
  }, []);

  if (!auth.loggedIn()) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/setup-2fa"
            element={
              <TwoFASetupRoute>
                <Setup2FA />
              </TwoFASetupRoute>
            }
          />
          <Route
            path="/verify-2fa"
            element={
              <TwoFASetupRoute>
                <Verify2FA />
              </TwoFASetupRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <div className="wrapper">
      <Router>
        <Navbar onRefresh={handleRefresh} botStatus={botStatus} />
        <div className="container-fluid">
          <Routes>
            <Route
              path="/"
              element={<EventsList ref={eventsListRef} />}
            />
            <Route
              path="/editappointment/:appointmentId"
              element={<EditAppointment />}
            />
            <Route
              path="/edit-profile"
              element={<EditProfile />}
            />
            <Route
              path="/bot-status"
              element={
                <AdminRoute>
                  <BotStatus />
                </AdminRoute>
              }
            />
            <Route
              path="/setup-bot"
              element={<SetupBot />}
            />
            <Route
              path="/administration"
              element={
                <AdminRoute>
                  <Administration />
                </AdminRoute>
              }
            />
            <Route
              path="*"
              element={<Navigate to="/" replace />}
            />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
